module.exports = __webpack_public_path__ + "static/video5-e04572a215b7f6adb3dc45ad9c07489b.png";